import React from 'react'
import classnames from 'classnames'
import formatMessage from 'format-message'
import Annotation from './Annotation'
import { saveCommentFn } from './utils.js'
import SecondaryControls from '../SecondaryControls'
import SelectionBox from './SelectionBox'
import { DEFAULT_AREA_ANNOTATION_COLOR } from '../constants'

import './SquareAnnotation.css'

export default function SquareAnnotation(props) {
  const {
    annotation,
    canEdit,
    commentReplies,
    isHovered,
    isSelected,
    onCreateAnnotation,
    onCurrentColorChange,
    onUpdateAnnotation,
    selectionBoxPadding,
    sessionUserObject,
    viewportHeight,
    viewportScale,
  } = props
  const updateColor = (color) => {
    onUpdateAnnotation(viewportHeight, viewportScale, { ...annotation, color })
    onCurrentColorChange(color, 'area')
  }
  const handleCommentSave = saveCommentFn({
    annotation,
    commentReplies,
    onUpdateAnnotation,
    viewportHeight,
    viewportScale,
    onCreateAnnotation,
    sessionUserObject,
  })

  const selectionBoxPaddingModified = selectionBoxPadding + 4
  const [[x1, y1], [x2, y2]] = annotation.rect
  const width = x2 - x1
  const height = y1 - y2

  const secondaryControls = (
    <SecondaryControls
      controlMode="area"
      currentColor={annotation.color}
      onCurrentColorChange={updateColor}
    />
  )

  const isVisible = isHovered || isSelected
  const classes = classnames('SquareAnnotation', {
    'SquareAnnotation--editable': canEdit,
  })

  return (
    <Annotation
      {...props}
      className={classes}
      iconColor={annotation.color ? annotation.color : DEFAULT_AREA_ANNOTATION_COLOR}
      height={height}
      id={annotation.id}
      isMovable={true}
      onCommentSave={handleCommentSave}
      render={(_isSvgContainerFocused) => [
        <SelectionBox
          height={height + selectionBoxPaddingModified * 2}
          isSelected={isSelected}
          isVisible={isVisible}
          key="selectionbox"
          width={width + selectionBoxPaddingModified * 2}
        />,
        <rect
          className="SquareAnnotation-presentation-rect"
          fill="none"
          height={height}
          key="rect"
          opacity={typeof annotation.opacity === 'number' ? annotation.opacity : 1}
          role="presentation"
          stroke={
            typeof annotation.color === 'string' ? annotation.color : DEFAULT_AREA_ANNOTATION_COLOR
          }
          strokeWidth={typeof annotation.width === 'number' ? annotation.width : 2}
          width={width}
          x={selectionBoxPaddingModified}
          y={selectionBoxPaddingModified}
        />,
        <rect
          className="SquareAnnotation-presentation-rect-hitpath"
          fill="none"
          height={height}
          key="hitpath"
          opacity={0.001}
          role="presentation"
          stroke={
            typeof annotation.color === 'string' ? annotation.color : DEFAULT_AREA_ANNOTATION_COLOR
          }
          strokeWidth={typeof annotation.width === 'number' ? annotation.width + 8 : 10}
          width={width}
          x={selectionBoxPaddingModified}
          y={selectionBoxPaddingModified}
        />,
      ]}
      secondaryControls={secondaryControls}
      selectionBoxPadding={selectionBoxPaddingModified}
      title={formatMessage('Area annotation')}
      width={width}
      x={x1}
      y={y2}
    />
  )
}
